import Highcharts from 'highcharts';
import addData from "highcharts/modules/data";
addData(Highcharts);

const $ = require('jquery');
const locale = $('html').attr('lang');

export const stats = {
  init: function() {

    if ($('table').hasClass('highchart')) {
      this.createChart();
    }
  },
  createChart: function(){
    const $btnTable = '<i class="fas fa-table"></i> '+texts.viewAsDataTableButtonText[locale];
    const $btnChart = '<i class="fas fa-chart-line"></i> '+texts.viewAsChartButtonText[locale];

    $('table.highchart').each(function( index ) {
      $(this).attr('id','datatable'+index);
      const tableId = $(this).attr('id');
      const tableTitle = $.trim($(this).find('caption').text());
      const chartType = $(this).attr('data-graph-type');

      // create toggle view buttons
      $(this).parent('.table-responsive').before('<button data-toggle="table" class="btn btn-link">'+$btnTable+'</button>');
      // create div for chart
      $(this).before('<div id="container'+index+'"></div>');

      const options = {
        data: { table: tableId },
        title: { text: tableTitle }
      }

      if (chartType == "line") {
        const lineParams = $.extend(true, options, lineOptions);
        const lineData = Highcharts.chart('container'+index, lineParams);
      }

      if (chartType == "column") {
        const columnParams = $.extend(true, options, columnOptions);
        const columnData = Highcharts.chart('container'+index, columnParams);
      }

      if (chartType == "pie") {
        const pieParams = $.extend(true, options, pieOptions);
        const pieData = Highcharts.chart('container'+index, pieParams);
      }
    });

    $('[data-toggle="table"]').click(function(){
      const $chartsWrapper = $(this).next('.table-responsive');
      const $thisCharts = $chartsWrapper.find('[data-highcharts-chart]');
      const $thisTable = $chartsWrapper.find('table');

      $(this).html($thisCharts.is(':visible') ? $btnChart : $btnTable);
      $thisCharts.toggleClass('d-none','d-block');
      $thisTable.toggleClass('d-none','d-block');
    });
  }
}

const lineOptions = {
  chart: {
    type: "line"
  },
  plotOptions: {
    series: {
      marker: {
        enabled: false
      }
    }
  },
  tooltip: {
    pointFormat: "{series.name} - <b>{point.y}</b>"
  }
}

const pieOptions = {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie',
    height: 500
  },
  tooltip: {
    percentageDecimals: 3,
    pointFormat: '<b>{point.percentage:.2f}%</b>'
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b> {point.percentage:.2f} %'
      }
    }
  },
  responsive: {
    rules: [{
      condition: {
          maxWidth: 575.98
      },
      chartOptions: {
        plotOptions: {
          pie: {
              dataLabels: {
                  enabled: false
              },
              showInLegend: true
          }
        },
      }
    }]
  },
  accessibility: {
    point: {
      valueSuffix: '%'
    }
  }
}

const columnOptions = {
  chart: {
    type: "column"
  }
}

const texts = {
  // textes des graphiques
  "columnMultiple": {
    "fr": "Graphique en colonnes avec {numSeries} séries de données",
    "nl": "Staafdiagram met {numSeries} gegevensreeksen"
  },
  "xAxisDescriptionSingular": {
    "fr": "Le graphique a 1 axe X affichant {names[0]}. {ranges[0]}",
    "nl": "Het diagram heeft één X-as waarop {names[0]} wordt weergegeven. {ranges[0]}"
  },
  "yAxisDescriptionSingular": {
    "fr": "Le graphique a 1 axe Y affichant {names[0]}. {ranges[0]}",
    "nl": "Het diagram heeft één Y-as waarop {names[0]} wordt weergegeven. {ranges[0]}"
  },
  "rangeFromTo": {
    "fr": "De {rangeFrom} à {rangeTo}.",
    "nl": "Van {rangeFrom} tot {rangeTo}."
  },
  "emptyChart": {
    "fr": "Pas de données",
    "nl": "Geen gegevens"
  },
  "viewAsDataTableButtonText": {
    "fr": "Vue tableau",
    "nl": "Tabelweergave"
  },
  "viewAsChartButtonText": {
    "fr": "Vue graphique",
    "nl": "Grafische weergave"
  }
};

// global options
Highcharts.setOptions({
  chart: {
    height: 400,
    style: {
      "fontFamily": "\"Libre Franklin\", \"Helvetica Neue\", \"Arial\", \"Noto Sans\", \"sans-serif\", \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
      "fontSize":"14px"
    },
    //borderColor: '#EBBA95',
    //borderWidth: 1,
    spacing: [10, 15, 15, 20]
  },
  colors: ['#4d4387','#afc437','#776abb','#6d7b2d','#352C61','#455011'],
  data: {
    startRow: 0,
    startColumn: 0
  },
  title: {
    text: null,
    align: "left",
    margin: 30,
    style: {
      fontSize: "24px",
      color: "#4C4583"
    }
  },
  xAxis: {
    allowDecimals: false,
    crosshair: true,
    title: {
      text: null
    }
  },
  yAxis: {
    title: {
      text: null
    }
  },
  credits: {
    enabled: false
  },
  exporting: {
    enabled: false
  },
  legend: {
    layout: "horizontal",
    maxHeight: 300,
    margin: 30
  },
  lang: {
    numericSymbols: null,
    decimalPoint: ',',
    thousandsSep: ' ',
    accessibility: {
      axis: {
        rangeFromTo: texts.rangeFromTo[locale],
        xAxisDescriptionSingular: texts.xAxisDescriptionSingular[locale],
        yAxisDescriptionSingular: texts.yAxisDescriptionSingular[locale]
      },
      chartTypes: {
        columnMultiple: texts.columnMultiple[locale],
        emptyChart: texts.emptyChart[locale]
      },
      table: {
        viewAsDataTableButtonText: texts.viewAsDataTableButtonText[locale]
      }
    }
  },
  accessibility: {
    screenReaderSection: {
      // beforeChartFormat: "<h5>{chartTitle}</h5><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>",
      onViewDataTableClick: function(e) {
        e.preventDefault();
        let tabTableID = $(this).closest('[role="tabpanel"]').next('[role="tabpanel"]').attr('aria-labelledby');
        $( 'button#'+tabTableID ).trigger( "click" );
      }
    }
  }
});